import {
    CustomProductListActions,
    CustomProductListState,
} from "@gaiaProfessionals/Store/ProductList/GAIAProductListReducer";
import { Handler } from "@gaiaProfessionals/Types/GAIAHandlerCreator";
import { createHandlerChainRunner, executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    page?: number;
};

type CustomHandlerType = Handler<Parameter, Parameter, CustomProductListActions, CustomProductListState>;

export const SetPageNumber: CustomHandlerType = props => {
    props.dispatch({
        type: "Custom/ProductList/SetPage",
        page: props.parameter.page,
    });
};

export const chain = [SetPageNumber];

const resetPageNumber = createHandlerChainRunner(chain, "GAIASetPageNumber");
export default resetPageNumber;
